import CategoryHeaderLinks from "../CategoryHeaderLinks";
import classnames from "classnames";
import ImagePill from "./ImagePill";

import styles from "./VisualCategoryHeaderLinks.css";

const VisualCategoryHeaderLinks = props => (
  <CategoryHeaderLinks
    {...props}
    ItemComponent={ImagePill}
    className={classnames(styles.sidePadding, styles.scrollBarMargin)}
    scrollSnapping={true}
  />
);

export default VisualCategoryHeaderLinks;
